import React, { useEffect, useState } from "react";
import { scrollToTop, getBounds } from './HelperFunctions';
import { rowSize } from './Constants';
import { useDidMountEffect } from './CustomHooks';

export const ProductPagination = ({ itemGroups, setPagedItemGroups, isLoading }) => {
    const maxPage = Math.ceil((itemGroups.length) / (rowSize * 4));
    const [page, setPage] = useState(() => {
        const storagePage = sessionStorage.getItem('page');
        return storagePage ? parseInt(storagePage) : 1;
    });

    useDidMountEffect(() => {
        goToPage(1);
    }, [itemGroups]);

    useEffect(() => {
        goToPage(page);
    }, [page]);

    if (isLoading || maxPage < 2) return null;
    var pages = [];
    for (var i = 1; i <= maxPage; i++) {
        pages.push(
            <option key={i} value={i} className="page-item tw-right-[13px] Page page-link tw-text-[19px] tw-w-[70px] tw-text-mine-shaft-950 focus:tw-bg-transparent">
                {i}
            </option>
        );
    }

    return (
        <div className="tw-w-full" id="filtering-pagination">
            <nav className="tw-mt-[1rem] md:tw-mt-0" aria-label="page navigation">
                <div className="pagination tw-justify-between tw-items-center tw-mb-[22px] tw-relative">
                    {page > 1 && (
                        < div onClick={prevPage} className="prev-page page-item tw-z-10 tw-cursor-pointer">
                            <a className="PrePage tk-trade-gothic-next tw-text-[17px] tw-text-mine-shaft-950 tw-flex tw-gap-[3px] tw-items-end" tabIndex="1">
                                <img src="/Content/img/sprites/prev-page.svg" width="17px" />
                                Previous
                            </a>
                        </div>
                    )}

                    <div className="tw-flex tw-justify-center tw-items-center tw-absolute tw-left-0 tw-right-0">
                        <label className="tw-m-0 label-select">
                            <select value={page} onChange={selectPage.bind(this)} style={{ height: "44px" }}
                                className="page-select tk-trade-gothic-next tw-text-[19px] tw-text-mine-shaft-950 tw-w-[70px] tw-pl-[13px] focus:tw-shadow-none focus:tw-outline-0 focus:tw-bg-transparent">
                                {pages}
                            </select>
                        </label>
                        <span className="tk-trade-gothic-next tw-text-[17px] tw-text-mine-shaft-950">&nbsp; of {maxPage} pages</span>
                    </div>

                    {page < maxPage && (
                        <div onClick={nextPage} className="next-page tw-cursor-pointer page-item tw-z-10 tw-ml-auto">
                            <a className="NextPage tk-trade-gothic-next tw-text-[17px] tw-text-mine-shaft-950 tw-flex tw-gap-[3px] tw-items-end">
                                Next
                                <img src="/Content/img/sprites/next-page.svg" width="17px" />
                            </a>
                        </div>
                    )}
                </div>
            </nav >
        </div >
    );

    function prevPage() {
        if (page > 1) {
            goToPage(page - 1);
        }
    }

    function selectPage(select) {
        goToPage(parseInt($(select.target).find(":selected").val()));
    }

    function nextPage() {
        if (page < maxPage) {
            goToPage(page + 1);
        }
    }

    function goToPage(page) {
        setPage(page);
        const [lowerBound, upperBound] = getBounds(page);
        setPagedItemGroups(itemGroups.slice(lowerBound, upperBound));
        scrollToTop();
        sessionStorage.setItem('page', page);
    }
}